export default __webpack_public_path__ + "static/media/Scarhide Belt.5df9daa6.jpg";